export enum Exchange {
  Binance = 'BINANCE',
  KuCoin = 'KUCOIN',
  MexC = 'MEXC',
  Coinbase = 'COINBASE',
  Kraken = 'KRAKEN',
  Phemex = 'PHEMEX',
  Bybit = 'BYBIT',
}
